import React from 'react';
import { useTranslation } from "react-i18next";
import ReportPage from '../ReportChart/ReportPage';
import { Apis } from "services/api";
import { getStopsByReason } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const ServiceStopReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();
  const { t } = useTranslation();

  const chartConfig = {
    id: 'service-stop',
    title: t("title.entityStopReasons", { entity: customCaptions?.service }),
    fetchData: async (params) => {
      return await getStopsByReason(params);
    },
    allowedChartTypes: ['horizontal-bar', 'pie'],
    defaultChartType: 'horizontal-bar',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{
        label: t("label.count")
      }]
    },
    series: [
      { label: t("label.count"), key: 'count', colors: getAllColors(), showLegend: false }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true
    },
    drilldown: {
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{
          label: t("label.entityCount", { entity: customCaptions?.model || 'Model' })
        }]
      },
      series: [
        {
          label: t("label.entityCount", { entity: customCaptions?.model || 'Model' }),
          key: 'count',
          showLegend: false
        }
      ],
      currentDrilldownLabel: `${customCaptions?.model || 'Model'}`,
      getParams: (dataPoint) => {
        return {
          stopReasonId: dataPoint.id
        };
      },
      drilldown: {
        axisConfig: {
          categoryAxis: { dataKey: 'label' },
          valueAxes: [{
            label: t("label.entityCount", { entity: customCaptions?.asset || 'Asset' })
          }]
        },
        series: [
          {
            label: t("label.entityCount", { entity: customCaptions?.asset || 'Asset' }),
            key: 'count',
            showLegend: false
          }
        ],
        currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
        getParams: (dataPoint) => {
          return {
            modelId: dataPoint.id
          };
        }
      }
    }
  };

  return (
    <ReportPage 
      title={t("title.entityStopReasons", { entity: customCaptions?.service })}
      chartConfig={chartConfig}
    />
  );
};

export default ServiceStopReport; 
